import { useState, useEffect } from 'react';
import salesforceEntitiesService from 'services/salesforceEntitiesService';

const useSideBarFunds = () => {
	const [entities, setEntities] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const loadEntities = async () => {
			setLoading(true);
			setError(null);

			try {
				const data = await salesforceEntitiesService.getEntities();
				setEntities(data || []);
			} catch (err) {
				setError('Failed to load funds');
			} finally {
				setLoading(false);
			}
		};

		loadEntities();
	}, []);

	return { entities, loading, error };
};

export default useSideBarFunds;
